import styled from 'styled-components'

import { media, transition } from '../../../utils/style-utils'

interface Props {
  isActive: boolean
}

export const Container = styled.div<Props>`
  position: relative;
  width: 50%;
  max-width: 20rem;
  ${transition('width', 0.5)}

  ${media.sm`
    ${(props: Props) => (props.isActive ? 'width: 100%' : 'width: 4rem')};
  `}
`
